module.exports = __webpack_public_path__ + "img/heyuan.cb874303.jpg";